import DOMPurify from 'dompurify';

/**
 * Sanitize Mermaid's rendered SVG output before it reaches innerHTML.
 * Defense-in-depth alongside securityLevel: 'strict' (Mermaid.jsx,
 * DocumentCanvas.jsx, DocumentEditor.jsx, DocumentMap.jsx) — strict mode
 * stops Mermaid from emitting HTML labels itself, but the diagram *source*
 * is still attacker-influenceable content (imported documents, AI output),
 * so the SVG it renders to is sanitized again here rather than trusted.
 */
export function sanitizeMermaidSvg(svg) {
  if (!svg) return '';
  return DOMPurify.sanitize(String(svg), {
    USE_PROFILES: { svg: true, svgFilters: true },
    FORBID_TAGS: ['foreignObject', 'script'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
  });
}
